export default __webpack_public_path__ + "static/media/caviar.ba5f667b.jpg";